<template>
  <div class="my-upload" :style="{ height: `${height}px`, width: `${width}px` }">
    <div v-if="!disabled" style="width: 100%; height: 100%">
      <el-upload
        class="custom-upload"
        :class="`bg${type}`"
        :accept="accept.toString()"
        :limit="1"
        :action="uploadUrl"
        :before-upload="fileUpload"
        :on-remove="removeFile"
        v-if="!url"
        v-loading="uploading">
        <div>
          <i class="el-icon-plus avatar-uploader-icon"></i>
        </div>
      </el-upload>
      <div v-else class="detail" :style="{ height: `${height}px`, width: `${width}px` }">
        <img :src="fileBaseUrl + url" class="avatar" />
      </div>
      <p class="name">
        {{ name }}
        <el-button type="text" v-if="url" @click="removeFile">修改</el-button>
        <el-popover v-if="popVisible" placement="right-start" trigger="hover" width="150">
          <div class="custom-content">仅可更换营业执照<br />(仅限于企业经营范围发生变更)</div>
          <i slot="reference" class="el-icon-warning-outline" style="font-size: 14px"></i>
        </el-popover>
      </p>
    </div>
    <div v-else>
      <div v-if="url" class="detail" :style="{ height: `${height}px`, width: `${width}px` }">
        <img :src="fileBaseUrl + url" class="avatar" />
      </div>
      <div v-else :style="{ height: `${height}px`, width: `${width}px` }" class="detail">
        <el-empty description="暂无图片" style="transform: translateY(-20px)"></el-empty>
      </div>
      <p class="name">{{ name }}</p>
    </div>
  </div>
</template>

<script>
import url from "@/api/url/hy_url";
const { baseUrl } = require("@/config");
import { reqUploadfile, discernUploadfile, ocrIdcardUploadfile } from "@/api/hy";
export default {
  data() {
    return {
      uploadUrl: baseUrl + url.upLoadUrl,
      fileBaseUrl: baseUrl + url.getFileUrl,
      url: "", //'20211117062154732-68-.jpg',
      accept: [".png", ".jpg", ".jpeg"],
      uploading: false,
    };
  },
  props: {
    validate: {
      type: String,
      default: "",
    },
    width: {
      type: Number,
      default: 360,
    },
    height: {
      type: Number,
      default: 240,
    },
    type: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      default: "",
    },
    value: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    popVisible: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    value(val) {
      this.url = val;
    },
  },
  methods: {
    fileUpload(file) {
      let type = this.accept.map(item => item.split(".")[1]);
      let reg = new RegExp(`^.+\\.(${type.join("|")})$`, "i");
      if (!reg.test(file.name)) {
        this.$message({
          message: `请上传${type.join("、")}格式的图片`,
          type: "error",
        });
        return false;
      }
      let maxSize = 10;
      let size = file.size / 1024 / 1024 < maxSize;
      if (!size) {
        this.$message.error(`上传图片大小不能超过 ${maxSize}MB!`);
        return false;
      }
      this.uploading = true;

      this.discernUploadfile(file);
      reqUploadfile(file)
        .then(ret => {
          if (ret.code == 0) {
            this.url = ret.data;
            this.uploading = false;
            this.$emit("input", this.url);
            console.log(this.$parent.$parent);
            this.$parent.$parent.validateField([this.validate]);
          }
        })
        .catch(() => {
          this.uploading = false;
        });
      return false;
    },
    removeFile() {
      this.url = "";
      this.$emit("input", this.url);
    },
    discernUploadfile(file) {
      if (this.type == "3") {
        discernUploadfile(file)
          .then(res => {
            if (res.code == 0) {
              this.$emit("tradingCertificate", res.data);
            } else {
              this.$message.error("营业执照解析失败,请手动输入");
            }
          })
          .catch(() => {
            this.$message.error("营业执照解析失败,请手动输入");
          });
      } else if (this.type == "2") {
        ocrIdcardUploadfile(file)
          .then(res => {
            if (res.code == 0) {
              this.$emit("ocrIdcardCertificate", res.data);
            } else {
              this.$message.error("身份证解析失败,请手动输入");
            }
          })
          .catch(() => {
            this.$message.error("身份证解析失败,请手动输入");
          });
      } else if (this.type == "1") {
        ocrIdcardUploadfile(file)
          .then(res => {
            if (res.code == 0) {
              this.$emit("idcardCertificate", res.data);
            } else {
              this.$message.error("身份证解析失败,请手动输入");
            }
          })
          .catch(() => {
            this.$message.error("身份证解析失败,请手动输入");
          });
      } else {
        return;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.my-upload {
  position: relative;
  margin-bottom: 30px;
  // border: 2px dashed #cecece;
}
.custom-upload {
  text-align: center;
  height: 100%;
  position: relative;
  background-color: #f7f7f7;
  .el-upload {
    width: 100%;
    height: 100%;
  }
  div {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    span {
      line-height: 1.5em;
    }
  }
  .el-loading-mask {
    z-index: 2;
  }
}
::v-deep {
  .avatar-uploader-icon {
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
    background: #cc9933;
    opacity: 0.5;
    color: white;
    font-size: 36px;
    border-radius: 50%;
  }
}
.bg1 {
  background: url("../../../../assets/img/id001.jpg") no-repeat;
  background-size: 100% 100%;
}
.bg2 {
  background: url("../../../../assets/img/id002.jpg") no-repeat;
  background-size: 100% 100%;
}
.bg3 {
  background: url("../../../../assets/img/id003.jpg") no-repeat;
  background-size: 100% 100%;
}
.detail {
  text-align: center;
  border: 1px solid #f5f5f5;
  display: flex;
  align-items: baseline;
  justify-content: center;
  img {
    max-width: 100%;
    // height: 100%;
    max-height: 100%;
    display: inline-block;
  }
  .remove {
    display: none;
  }

  ::v-deep .el-empty__description {
    margin-top: 0 !important;
  }
  // &:hover .remove{
  //   display: inline-block;
  //   width: 100%;
  //   height: 100%;
  //   position: absolute;
  //   left: 0;
  //   top: 0;
  //   background: rgba(0,0,0,0.2);
  //   i{
  //     position: absolute;
  //     top: 50%;
  //     left: 50%;
  //     transform: translate(-50%,-50%);
  //     cursor: pointer;
  //   }
  // }
}
.name {
  text-align: center;
  margin-top: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
  span {
    cursor: pointer;
    // color: #0294ff;
  }
  .el-icon-warning-outline {
    font-size: 18px !important;
    transform: translateY(1px);
  }
}
</style>
